import { Flex, Text, UnstyledButton } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  onClick: () => void;
  disabled?: boolean;
  icon: React.ReactNode;
  label: string;
  style?: React.CSSProperties;
};

export function SidebarPillButton({ onClick, disabled, icon, label, style }: Props) {
  return (
    <UnstyledButton
      onClick={onClick}
      disabled={disabled}
      style={{
        height: 32,
        paddingLeft: 'var(--mantine-spacing-xs)',
        paddingRight: 'var(--mantine-spacing-sm)',
        backgroundColor: 'var(--mantine-color-orange-2)',
        borderRadius: 'var(--mantine-radius-xl)',
        zIndex: 10,
        whiteSpace: 'nowrap',
        opacity: disabled ? 0.5 : 1,
        transition: 'opacity 0.2s ease-in-out',
        ...style,
      }}
    >
      <Flex align="center" gap="xxxs" h="100%">
        {icon}
        <Text size="textSm" fw={FONT_WEIGHTS.bold} c="orange.6">
          {label}
        </Text>
      </Flex>
    </UnstyledButton>
  );
}
